import React, { useEffect, useState } from "react";
import "./services/i18n";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Layout from "./layout/Layout";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import Staffs from "./pages/Staffs";
import Transactions from "./pages/Transactions";
import CreatePatient from "./pages/CreatePatient";
import CreateStaff from "./pages/CreateStaff";
// import useStore from "./hook/store";
import PrivateRoute from "./pages/PrivateRoute";
import SinglePatient from "./pages/SinglePatient";
import SearchPatient from "./pages/SearchPatient";
import TakenTreatment from "./pages/TakenTreatment";
import CreateTakenTreatment from "./pages/CreateTakenTreatment";
import Payment from "./pages/Payment";
import Treatments from "./pages/Treatments";
import CreateTreatment from "./pages/CreateTreatment";
import Register from "./pages/Register";
import Branches from "./pages/Branches";
import CreateBranch from "./pages/CreateBranch";
import { toast } from "react-toastify";
import io from "socket.io-client";
import { useQuery } from "@tanstack/react-query";
import Notifications from "./pages/Notifications";
import { joinGroup } from "./services/post.service";
import auth from "./services/auth";
import Patient from "./pages/Patient";
import { patient, takenTreament, user } from './common/type'
import RegisterSAAS from "./pages/RegisterSAAS";
import Front from "./pages/Front";
import Users from "./pages/Users";
import ExpextedPayment from "./pages/ExpectedPayment";

function App() {
  const [user, setUser] = useState<user | null>(null)
  const [takenTreatment, setTakenTreatment] = useState<takenTreament | null>(null)
  const [patient, setPatient] = useState<patient | null>(null)
  const [notFCount, setFCount] = useState<number>(0)

  useEffect(() => {
    const func = async () => {
      await auth.getUser().then((res) => {
        setUser(res.data);
      }).catch((err) => console.log(err))
    }

    func();
  }, [setUser])

  const con = () => {
    const conn = io(process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV : process.env.REACT_APP_PROD, {
      autoConnect: true
    });

    return !user ? null : conn;
  };

  const { data: conn, isFetching } = useQuery({
    queryKey: ["notify"],
    queryFn: () => con(),
  });

  useEffect(() => {
    joinGroup()
      .then(() => {
        console.log('joined')
      }).catch((err) => {
        console.log(err)
      })
    if (!isFetching && conn?.disconnected) {
      conn.connect()
      conn.on("recieve", (message: string) => {
        toast.warn(message);
      });
    }
  }, [conn, isFetching]);

  return (
    <BrowserRouter>
      <Layout user={user} setUser={setUser} notFCount={notFCount}>
        <Routes>
          <Route element={user ? <PrivateRoute setUser={setUser} user={user}>{<Home />}</PrivateRoute> : <Front />} path="/" />
          <Route element={<Login setUser={setUser} user={user} />} path="/login" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><SearchPatient user={user} setPatient={setPatient} /></PrivateRoute>} path="/search/patient" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><Register /></PrivateRoute>} path="/register" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><RegisterSAAS /></PrivateRoute>} path="/register/saas" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><SinglePatient user={user}
            setTakenTreatment={setTakenTreatment} patient={patient} /></PrivateRoute>} path="/patient" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><Patient user={user} /></PrivateRoute>} path="/patients" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><Payment takenTreatment={takenTreatment} patient={patient} /></PrivateRoute>} path="/payment" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><TakenTreatment takenTreatment={takenTreatment}
            user={user}/></PrivateRoute>} path="/patient/taken/treatment" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><CreateTakenTreatment patient={patient} /></PrivateRoute>} path="/add/treatment" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><CreatePatient /></PrivateRoute>} path="/create/patient" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><CreateTreatment /></PrivateRoute>} path="/create/treatment" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><CreateStaff /></PrivateRoute>} path="/create/staff" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><CreateBranch /></PrivateRoute>} path="/create/branch" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><Users /></PrivateRoute>} path="/users" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><Staffs /></PrivateRoute>} path="/staffs" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><ExpextedPayment /></PrivateRoute>} path="/expected" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><Branches /></PrivateRoute>} path="/branches" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><Transactions /></PrivateRoute>} path="/transactions" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><Treatments /></PrivateRoute>} path="/treatments" />
          <Route element={<PrivateRoute setUser={setUser} user={user}><Notifications setFCount={setFCount}  /></PrivateRoute>} path="/notifications" />
          <Route element={<NotFound />} path="*" />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
